module.exports = __webpack_public_path__ + "static/media/whatsapp.4ddb527d.svg";